import { Flex, Tab, TabList, TabProps } from '@chakra-ui/react'
import { colors, SubTab } from '@hb/shared'
import { useProfile } from '../../../../contexts/user/ProfileContext'
import { MenuTabList } from '../../../shared/Nav/MenuTabList'

const DesktopTab = (props: TabProps) => (
  <Tab
    mr={3}
    background="white"
    fontSize="sm"
    _selected={{ background: colors.pink.hex, color: '#333' }}
    shadow="md"
    {...props}
  />
)

export const DesktopTabs = ({
  tabs,
  mobileLayout,
  handleSelect,
}: {
  tabs: Array<SubTab>
  mobileLayout: boolean
  handleSelect: (path: string) => void
}) => {
  const { subTab } = useProfile()

  if (mobileLayout) {
    return <MenuTabList onSelect={handleSelect} tabs={tabs} path={subTab?.path} />
  }
  return (
    <Flex
      borderBottom={mobileLayout ? '1px solid #cdcdcd' : 'none'}
      bg={mobileLayout ? 'white' : 'transparent'}
      gap={0}
      px={mobileLayout ? 0 : 4}
      pt={mobileLayout ? 0 : 2}
      w="100%">
      <TabList>
        {tabs.map((tab, i) => (
          <DesktopTab key={i}>{tab.name}</DesktopTab>
        ))}
      </TabList>
    </Flex>
  )
}
